import settings from '@/constants/constants';
import type { IDoctorAvailabilityResponse } from '@/hooks/patient/useGetPatientDoctorAvailability';
import type { PatientOrder } from '@/hooks/patient/useGetPatientOrders';
import axios from 'axios';

const API_URL = `${settings.url}/patient`;

export interface PatientOrderTrackingStatus {
  orderCode: string;
  orderDate: string;
  orderTimezone: string;
  trackingId: string | null;
  carrier: string | null;
  orderStatus: number;
}

const getPatientOrders = () => axios.get<PatientOrder[]>(`${API_URL}/orders`);

const getPatientDoctorAvailability = (patientId?: string | number) =>
  axios.get<IDoctorAvailabilityResponse>(`${API_URL}/currentDoctorsAvailability/${patientId}`);

export const PatientService = {
  getPatientDoctorAvailability,
  getPatientOrders,
};
